import { render, staticRenderFns } from "./FilesViewFileDropEmptyContent.vue?vue&type=template&id=5e7d8fe0&scoped=true"
import script from "./FilesViewFileDropEmptyContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesViewFileDropEmptyContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilesViewFileDropEmptyContent.vue?vue&type=style&index=0&id=5e7d8fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d8fe0",
  null
  
)

export default component.exports